// EV Cable Hub — PDP variant + qty + install + add-to-cart
(function () {
  'use strict';

  function ProductForm(form, productData) {
    this.form = form;
    this.product = productData;
    this.installPrice = window.theme && window.theme.installPrice ? window.theme.installPrice : 0;
    this.installVariantId = window.theme && window.theme.installVariantId ? window.theme.installVariantId : null;
    this.qty = 1;
    this.installAdd = false;
    this.options = [];
    var groups = this.form.querySelectorAll('.variant-group');
    for (var i = 0; i < groups.length; i++) this.options.push(null);
    this.bind();
    this.syncFromInitial();
  }

  ProductForm.prototype.bind = function () {
    var self = this;
    var swatches = this.form.querySelectorAll('.swatch, .colour-swatch');
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () { self.onSwatch(btn); });
    });
    var inc = this.form.querySelector('[data-qty-increment]');
    var dec = this.form.querySelector('[data-qty-decrement]');
    if (inc) inc.addEventListener('click', function () { self.setQty(self.qty + 1); });
    if (dec) dec.addEventListener('click', function () { self.setQty(Math.max(1, self.qty - 1)); });
    var install = this.form.querySelector('[data-install-toggle]');
    if (install) install.addEventListener('change', function (e) {
      self.installAdd = e.target.checked;
      var label = self.form.querySelector('.install-upsell');
      if (label) label.classList.toggle('is-on', self.installAdd);
      self.update();
    });
    this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
  };

  ProductForm.prototype.syncFromInitial = function () {
    var groups = this.form.querySelectorAll('.variant-group');
    var self = this;
    groups.forEach(function (g, i) {
      var active = g.querySelector('.active');
      if (active) self.options[i] = active.getAttribute('data-option-value');
    });
    this.update();
  };

  ProductForm.prototype.onSwatch = function (btn) {
    var idx = parseInt(btn.getAttribute('data-option-index'), 10) || 0;
    var siblings = btn.parentElement ? btn.parentElement.querySelectorAll('.swatch, .colour-swatch') : [];
    siblings.forEach(function (s) { s.classList.remove('active'); });
    btn.classList.add('active');
    this.options[idx] = btn.getAttribute('data-option-value');
    var sel = this.form.querySelector('[data-selected-value-' + idx + ']');
    if (sel) sel.textContent = this.options[idx];
    this.update();
  };

  ProductForm.prototype.setQty = function (n) {
    this.qty = n;
    var disp = this.form.querySelector('[data-qty-display]');
    var input = this.form.querySelector('[data-qty-input]');
    if (disp) disp.textContent = n;
    if (input) input.value = n;
    this.update();
  };

  ProductForm.prototype.match = function () {
    if (!this.product.variants) return null;
    var opts = this.options;
    return this.product.variants.find(function (v) {
      var arr = [v.option1, v.option2, v.option3];
      for (var i = 0; i < opts.length; i++) {
        if (opts[i] === null || opts[i] === undefined) continue;
        if (opts[i] !== arr[i]) return false;
      }
      return true;
    });
  };

  ProductForm.prototype.update = function () {
    var variant = this.match();
    var idInput = this.form.querySelector('[data-variant-id]');
    var submit = this.form.querySelector('[data-add-to-cart]');
    var price = this.form.querySelector('[data-price]');
    var compareAt = this.form.querySelector('[data-compare-at]');
    var totalEl = this.form.querySelector('[data-total-price]');

    if (!variant) {
      if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (submit) submit.disabled = !variant.available;
    if (price) price.textContent = window.theme.formatMoney(variant.price);
    if (compareAt) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareAt.textContent = window.theme.formatMoney(variant.compare_at_price);
        compareAt.style.display = '';
      } else {
        compareAt.style.display = 'none';
      }
    }
    var total = (variant.price + (this.installAdd ? this.installPrice : 0)) * this.qty;
    if (totalEl) totalEl.textContent = window.theme.formatMoney(total);
    if (submit) {
      if (variant.available) {
        submit.innerHTML = 'Add to bag · <span class="ticker" data-total-price>' + window.theme.formatMoney(total) + '</span>';
      } else {
        submit.textContent = 'Sold out';
      }
    }
  };

  ProductForm.prototype.onSubmit = function (e) {
    e.preventDefault();
    var self = this;
    var idInput = this.form.querySelector('[data-variant-id]');
    var id = idInput ? parseInt(idInput.value, 10) : null;
    if (!id) return;
    var items = [{ id: id, quantity: this.qty }];
    if (this.installAdd && this.installVariantId) {
      items.push({ id: this.installVariantId, quantity: this.qty });
    }
    var submit = this.form.querySelector('[data-add-to-cart]');
    if (submit) submit.disabled = true;
    fetch(window.theme.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      if (submit) {
        submit.disabled = false;
        var orig = submit.innerHTML;
        submit.innerHTML = '✓ Added to bag';
        setTimeout(function () { self.update(); }, 1800);
      }
    }).catch(function () {
      if (submit) submit.disabled = false;
    });
  };

  function init() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      var pid = form.getAttribute('data-product-id');
      var script = document.getElementById('ProductJson-' + pid);
      if (!script) return;
      try {
        var data = JSON.parse(script.textContent);
        new ProductForm(form, data);
      } catch (e) { /* noop */ }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
